import { Dialog } from '@cvg/react-components'

import Header from './Header'

Dialog.Header = Header

export default Dialog
